export default "__VITE_ASSET__sqfed3Cy__"